import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import LoginFake from '@/components/LoginFake'
//ADMIN ROUTE
import GoAdmin from '@/components/admin/GoAdmin'

import Dashboard from '@/components/admin/Dashboard'
import Movies from '@/components/admin/Movies'
import Series from '@/components/admin/Series'
import Servers from '@/components/admin/Servers'
import Captions from '@/components/admin/Captions'
import Users from '@/components/admin/Users'
import Settings from '@/components/admin/Settings'
import About from '@/components/admin/About'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { 
      path: '/', 
      name: 'LoginFake', 
      component: LoginFake 
    },
    { 
      path: '/gologin', 
      name: 'Login', 
      component: Login 
    },
    //BEGIN ADMIN ROUTE
    { 
	path: '/goadmin', component: GoAdmin, redirect: '/goadmin/movies', meta: { title: 'GoAdmin', requiresAuth: true },
		children: [
      { 
        path: 'dashboard',
        name: 'Dashboard', 
        component: Dashboard, 
        meta: { title: 'Dashboard', requiresAuth: true } 
      },
			{ 
			  path: 'movies',
			  name: 'Movies', 
			  component: Movies, 
			  meta: { title: 'Movies', requiresAuth: true } 
			},
      { 
        path: 'series',
        name: 'Series', 
        component: Series, 
        meta: { title: 'Series', requiresAuth: true } 
      },
      { 
        path: 'servers', 
        name: 'Servers', 
        component: Servers, 
        meta: { title: 'Servers', requiresAuth: true } 
      },
      { 
        path: 'captions', 
        name: 'Captions', 
        component: Captions, 
        meta: { title: 'Captions', requiresAuth: true } 
      },
      { 
        path: 'settings', 
        name: 'Settings', 
        component: Settings, 
        meta: { title: 'Settings', requiresAuth: true } 
      },
			{ 
			  path: 'users', 
			  name: 'Users', 
			  component: Users, 
			  meta: { title: 'Users', requiresAuth: true } 
			},
      { 
        path: 'about', 
        name: 'About', 
        component: About, 
        meta: { title: 'About', requiresAuth: true } 
      }
		]
		//
    }
  ]
})

const token = localStorage.getItem('token')
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js